import { render, staticRenderFns } from "./CredentialSampleSave.vue?vue&type=template&id=9cb22858&scoped=true&"
import script from "./CredentialSampleSave.vue?vue&type=script&lang=js&"
export * from "./CredentialSampleSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb22858",
  null
  
)

export default component.exports